import Cookies from 'js-cookie';

export const getSessionId = () => Cookies.get('session');

export default getSessionId;


// WEBPACK FOOTER //
// ./src/utils/auth/getSessionId.js